
const X_COUNT = 24;
export const SERIES_NAME = (t) => ({
  batteryCharge: `${t('key124')}(+)`,
  batteryDischarge: `${t('key125')}(-)`,
  demandPrediction: t('key703'),
  demand: t('key126'),
  solarPrediction: t('key705'),
  solar: t('key706'),
})

const GRAPH_BASE_DATA = (t) => [
  {
    name: SERIES_NAME(t).batteryCharge,
    type: 'bar',
    strokeWidth: 0,
    dashArray: 0,
    color: "#52d546",
    fillType: "solid",
    opacityFrom: 1,
    opacityTo: 1,
    data: Array(X_COUNT).fill(null),
  },
  {
    name: SERIES_NAME(t).batteryDischarge,
    type: 'bar',
    strokeWidth: 0,
    dashArray: 0,
    color: "#DBEEFF", 
    fillType: "solid",
    opacityFrom: 1,
    opacityTo: 1,
    data: Array(X_COUNT).fill(null),
  },
  // {
  //   name: SERIES_NAME.demandPrediction,
  //   type: 'line',
  //   strokeWidth: 2,
  //   dashArray: 5,
  //   color: "#5ECED5",
  //   fillType: "solid",
  //   opacityFrom: 1,
  //   opacityTo: 1,
  //   data: Array(X_COUNT).fill(null),
  // },
  {
    name: SERIES_NAME(t).demand,
    type: 'line',
    strokeWidth: 2,
    dashArray: 0,
    color: "#3EA2FF",
    fillType: "solid",
    opacityFrom: 1,
    opacityTo: 1,
    data: Array(X_COUNT).fill(null),
  },
  // {
  //   name: SERIES_NAME.solarPrediction,
  //   type: 'area',
  //   strokeWidth: 2,
  //   dashArray: 5,
  //   color: "#F8B551",
  //   fillType: "gradient",
  //   opacityFrom: 0.5,
  //   opacityTo: 0,
  //   data: Array(X_COUNT).fill(null),
  // },
  {
    name: SERIES_NAME(t).solar,
    type: 'line',
    strokeWidth: 2,
    dashArray: 0,
    color: "#F8B551",
    fillType: "solid",
    opacityFrom: 1,
    opacityTo: 1,
    data: Array(X_COUNT).fill(null),
  },
];

function getCurrentHour() {
  const date = new Date();
  const hours = date.getHours();
  return hours;
}

function getXNames() {
  return [
    '-12h', '-11h', '-10h', '-9h', '-8h', '-7h', '-6h',
    '-5h', '-4h', '-3h', '-2h', '-1h', ['현재', `(${getCurrentHour()}시)`],
    '+1h', '+2h', '+3h', '+4h', '+5h', '+6h', '+7h',
    '+8h', '+9h', '+10h', '+11h', 
  ]
}

export function initSeriesData(t) {
  return GRAPH_BASE_DATA(t).map(data => {
    return {
      name: data.name,
      type: data.type,
      data: data.data.slice(),
    }
  });
}
export function updateSeriesData({ seriesData, updateData, name }) {
  const currenHour = getCurrentHour(); // 현재 시간 (0~23)
  const seriesIndex = seriesData?.findIndex(series => series.name === name) || -1;
  if (seriesIndex === -1) return; // 해당 name의 시리즈가 없으면 종료
  const series = seriesData[seriesIndex];

  if (!series) return; // 해당 name의 시리즈가 없으면 종료

  updateData.forEach(({ hh, data: value }) => {
    let diff = hh - currenHour; // 현재 시간과의 차이 계산
    let index = 12 + diff; // X축 배열에서의 인덱스 변환

    // 24시간을 벗어나지 않도록 보정 (음수 또는 24 이상이면 0~23 사이로 맞춤)
    if (index < 0) {
      index += 24;
    } else if (index >= 24) {
      index -= 24;
    }

    // 배열 범위 내에서 값 업데이트
    if (index >= 0 && index < series.data.length) {
      series.data[index] = value;
    }
  });

  return seriesData;
}

export function setOptions(seriesData, t) {
  return {
    chart: {
      type: 'area',
      stacked: true
    },
    stroke: {
      width: setOptionData(GRAPH_BASE_DATA(t), 'strokeWidth'),
      lineCap: "butt",
      dashArray: setOptionData(GRAPH_BASE_DATA(t), 'dashArray'),
    },
    colors: setOptionData(GRAPH_BASE_DATA(t), 'color'),
    xaxis: {
      categories: getXNames(),
      labels: {
        style: {
          fontSize: '12px',
        }
      },
      tickAmount: getXNames().length, // 모든 라벨을 강제로 표시
    },
    grid: {
      show: true,
      borderColor: '#e7e7e7',
      position: 'back',
      xaxis: {
        lines: {
            show: true
        }
      },   
      yaxis: {
          lines: {
              show: false
          }
      },  
    },
    fill: {
      type: setOptionData(GRAPH_BASE_DATA(t), 'fillType'),
      gradient: {
        shade: "light",
        type: "vertical",
        opacityFrom: setOptionData(GRAPH_BASE_DATA(t), 'opacityFrom'),
        opacityTo: setOptionData(GRAPH_BASE_DATA(t), 'opacityTo'),
      },
    },
    legend: {
      itemMargin: {
        horizontal: 10,
        vertical: 30
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      }
    },
    annotations: { // line chart에 lineCap을 적용하기 위해 사용 (라이브러리 지원: round, butt, square -> point 없음)
      points: getAnnotationPoints(GRAPH_BASE_DATA(t), seriesData, getXNames()),
      yaxis: [
        {
          y: 0, // 중앙선의 Y값 (예: 0)
          borderColor: '#f0f0f0', // 중앙선 색상
          strokeDashArray: 0, // 실선 스타일
          opacity: 0.7, // 선의 투명도
        },
      ],
      xaxis: [
        {
          x: "-6h", // 중앙선의 Y값 (예: 0)
          borderColor: '#c3c3c3', // 중앙선 색상
          strokeDashArray: 0, // 실선 스타일
          opacity: 1, // 선의 투명도
        },
        {
          x: "+6h", // 중앙선의 Y값 (예: 0)
          borderColor: '#c3c3c3', // 중앙선 색상
          strokeDashArray: 0, // 실선 스타일
          opacity: 1, // 선의 투명도
        },
      ]
    }
  }
}

function setOptionData(graphBaseData, objKey) {
  
  return graphBaseData.map(data => data[objKey]);
}

function getAnnotationPoints(graphBaseData, seriesData, categories) {
  const targetSeries = [SERIES_NAME.demand, SERIES_NAME.solar]; // 대상 시리즈
  const points = [];
  if (!seriesData || seriesData.length === 0) return points;
  seriesData.forEach(series => {
    if (targetSeries.includes(series.name)) {
      // 해당 시리즈의 기본 설정 찾기
      const baseSeries = graphBaseData.find(base => base.name === series.name);
      if (!baseSeries) return;

      const color = baseSeries.color; // 기본 데이터에서 색상 가져오기

      // 시작점 찾기
      const locateStartIndex = series.data.findIndex(value => value !== null);
      // 끝점 찾기
      const locateEndIndex = series.data.length - 1 - series.data.slice().reverse().findIndex(value => value !== null);
      
      // 시작점과 끝점이 유효한 경우만 추가
      if (locateStartIndex >= 0 && locateStartIndex < categories.length) {
        points.push({
          x: categories[locateStartIndex], // X축 카테고리에서 정확한 위치
          y: series.data[locateStartIndex],
          marker: {
            size: 3,
            fillColor: color,
            strokeColor: color,
            radius: 2,
          }
        });
      }

      if (locateEndIndex >= 0 && locateEndIndex < categories.length) {
        points.push({
          x: categories[locateEndIndex], // X축 카테고리에서 정확한 위치
          y: series.data[locateEndIndex],
          marker: {
            size: 3,
            fillColor: color,
            strokeColor: color,
            radius: 2,
          }
        });
      }
    }
  });

  return points;
}
